import { Badge } from './badge';
import { FileEdit, Clock, CircleCheck, XCircle, AlertTriangle, Circle } from 'lucide-react';

interface StatusBadgeProps {
  dot: 'gray' | 'blue' | 'green' | 'red' | 'orange' | 'purple';
  label: string;
}

const dotToVariant = {
  gray: 'draft',
  blue: 'info',
  green: 'success',
  red: 'error',
  orange: 'warning',
  purple: 'purple',
} as const;

const dotToIcon = {
  gray: FileEdit,
  blue: Clock,
  green: CircleCheck,
  red: XCircle,
  orange: AlertTriangle,
  purple: Circle,
} as const;

export function StatusBadge({ dot, label }: StatusBadgeProps) {
  const Icon = dotToIcon[dot];
  return (
    <Badge variant={dotToVariant[dot]}>
      <Icon className="h-3 w-3 mr-1" />
      {label}
    </Badge>
  );
}
